export enum SortingType {
  Metadata = "Metadata",
  Property = "Property",
  StatusHistory = "StatusHistory",
}
